/*
 * @Author: your name
 * @Date: 2022-01-05 18:30:43
 * @LastEditTime: 2023-04-21 19:32:52
 * @LastEditors: yuTian
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \datacenter\src\utils\axios\index.js
 */
import axios from 'axios'
import store from '@/store'
import * as uniteHandle from '@utils/unite.js'

import {
  requestSuccess,
  requestFail,
  responseSuccess,
  responseFail
} from '@conf'

// 站点统一的配置
const instance = axios.create({
  timeout: 150000,
  contentType: 'application/json',
  complete: function(xhr, status) {
    if (status === 'timeout') {
      xhr.abort()
    }
  }
})
// 注入请求拦截
instance.interceptors.request.use(requestSuccess, requestFail)

// 注入响应拦截
instance.interceptors.response.use(responseSuccess, responseFail)

// 过程组装请求
export default async P => {
  return new Promise((resolve, reject) => {
    if (P.getCache && uniteHandle.cacheReport[P.url]) {
      resolve(uniteHandle.cacheReport[P.url])
      return
    }
    instance(P)
      .then(res => {
        if (P.cacheData) uniteHandle.cacheReport[P.url] = res
        uniteHandle[P.url] && store.state.unionReport
          ? resolve(uniteHandle[P.url](res))
          : resolve(res)
        P.success && P.success(res)
      })
      .catch(err => {
        reject(err)
        P.error && P.error(err)
      })
  })
} //web请求: ajax封装
